<div class="modal-header">
  <h4 class="modal-title">Edit Customer Filters</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group clearfix">
    <button type="button" class="btn btn-primary float-right ml-2"
            (click)="handleSubmit()">
      Apply
    </button>
    <button type="button" class="btn btn-secondary float-right"
            (click)="handleClearAll()">
      Clear All
    </button>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.home_location_id = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-12 pl-0">
        <label for="home_location_id">Home Location</label>

        <select class="custom-select"
                id="home_location_id" name="home_location_id"
                [(ngModel)]="filters.home_location_id">
          <option [ngValue]="undefined">All Locations</option>
          <option *ngFor="let loc of locations"
                  [ngValue]="loc.id">
            {{ loc.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.age_min = undefined;filters.age_max = undefined;">
      Clear
    </button>

    <div class="row">
      <div class="col-6 pl-0">
        <label for="age_min">Minimum Age</label>
        <input class="form-control" id="age_min" name="age_min"
               type="number" min="0" step="1"
               [(ngModel)]="filters.age_min">
      </div>
      <div class="col-6 pl-0">
        <label for="age_max">Maximum Age</label>
        <input class="form-control" id="age_max" name="age_max"
               type="number" min="0" step="1"
               [(ngModel)]="filters.age_max">
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_active_membership = undefined; filters.member_active_membership_name = undefined;">
      Clear
    </button>

    <label>Active Membership Status</label>

    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_active_membership" id="has_active_membership_true"
             [value]="true" [(ngModel)]="filters.has_active_membership">
      <label class="form-check-label" for="has_active_membership_true">
        Has active membership
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_active_membership" id="has_active_membership_false"
             [value]="false" [(ngModel)]="filters.has_active_membership"
             (ngModelChange)="handleHasActiveMembershipChange()">
      <label class="form-check-label" for="has_active_membership_false">
        Does not have active membership
      </label>
    </div>
  </div>

  <div class="form-group" *ngIf="filters.has_active_membership === true">
    <label for="member_active_membership_name">
      Active Membership Name
    </label>
    <input class="form-control" id="member_active_membership_name" name="member_active_membership_name"
           type="text"
           [(ngModel)]="filters.member_active_membership_name">
    <small class="form-text text-muted">
      This will return only customers with an active membership whose name contains the provided text. To return customers with any active membership, leave this blank.
    </small>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_frozen_membership = undefined">
      Clear
    </button>

    <label>Frozen Membership Status</label>

    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_frozen_membership" id="has_frozen_membership_true"
             [value]="true" [(ngModel)]="filters.has_frozen_membership">
      <label class="form-check-label" for="has_frozen_membership_true">
        Has frozen membership
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_frozen_membership" id="has_frozen_membership_false"
             [value]="false" [(ngModel)]="filters.has_frozen_membership">
      <label class="form-check-label" for="has_frozen_membership_false">
        Does not have frozen membership
      </label>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_active_youth_programming_membership = undefined">
      Clear
    </button>

    <label>Youth Programming Membership Status</label>

    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="has_active_youth_programming_membership" id="has_active_youth_programming_membership_true"
             [value]="true" [(ngModel)]="filters.has_active_youth_programming_membership">
      <label class="form-check-label" for="has_active_youth_programming_membership_true">
        Has active youth programming membership
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="has_active_youth_programming_membership" id="has_active_youth_programming_membership_false"
             [value]="false" [(ngModel)]="filters.has_active_youth_programming_membership">
      <label class="form-check-label" for="has_active_youth_programming_membership_false">
        Does not have active youth programming membership
      </label>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_active_non_youth_programming_membership = undefined">
      Clear
    </button>

    <label>Non-Youth Programming Membership Status</label>

    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="has_active_non_youth_programming_membership" id="has_active_non_youth_programming_membership_true"
             [value]="true" [(ngModel)]="filters.has_active_non_youth_programming_membership">
      <label class="form-check-label" for="has_active_non_youth_programming_membership_true">
        Has active non-youth programming membership
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="has_active_non_youth_programming_membership" id="has_active_non_youth_programming_membership_false"
             [value]="false" [(ngModel)]="filters.has_active_non_youth_programming_membership">
      <label class="form-check-label" for="has_active_non_youth_programming_membership_false">
        Does not have active non-youth programming membership
      </label>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_membership_with_future_start = undefined">
      Clear
    </button>

    <label>Future Start Membership Status</label>

    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="has_membership_with_future_start" id="has_membership_with_future_start_true"
             [value]="true" [(ngModel)]="filters.has_membership_with_future_start">
      <label class="form-check-label" for="has_membership_with_future_start_true">
        Has membership set to start in the future
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="has_membership_with_future_start" id="has_membership_with_future_start_false"
             [value]="false" [(ngModel)]="filters.has_membership_with_future_start">
      <label class="form-check-label" for="has_membership_with_future_start_false">
        Does not have membership set to start in the future
      </label>
    </div>
  </div>

  <hr>

  <app-date-range-filter
    [label]="'First Became a Member'"
    [idPrefix]="'first_membership_timestamp'"
    [(min)]="filters.first_membership_timestamp_min"
    [(max)]="filters.first_membership_timestamp_max"
    [(range)]="filters.first_membership_timestamp_range">
    <small class="form-text text-muted">If a "first became a member" date range is provided, then only current and former membership holders will be returned.</small>
  </app-date-range-filter>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.number_of_available_entry_passes_min = undefined;filters.number_of_available_entry_passes_max = undefined;">
      Clear
    </button>

    <label>Number Of Entry Passes</label>

    <div class="row">
      <div class="col-6 form-group pl-0">
        <label for="number_of_available_entry_passes_min">Minimum</label>
        <input class="form-control" id="number_of_available_entry_passes_min" name="number_of_available_entry_passes_min"
               type="number" min="0" step="1"
               [(ngModel)]="filters.number_of_available_entry_passes_min">
      </div>
      <div class="col-6 form-group pl-0">
        <label for="number_of_available_entry_passes_max">Maximum</label>
        <input class="form-control" id="number_of_available_entry_passes_max" name="number_of_available_entry_passes_max"
               type="number" min="0" step="1"
               [(ngModel)]="filters.number_of_available_entry_passes_max">
      </div>
    </div>
  </div>

  <hr>

  <app-date-range-filter
    [label]="'Account Created Date'"
    [idPrefix]="'created_at'"
    [(min)]="filters.created_at_min"
    [(max)]="filters.created_at_max"
    [(range)]="filters.created_at_range"></app-date-range-filter>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.address_postcode = undefined">
      Clear
    </button>

    <label for="address_postcode">
      {{ orgConfigService.getPostcodeName(true, false) }}
    </label>

    <div class="row">
      <div class="col-6 pl-0">
        <input class="form-control" id="address_postcode" name="address_postcode"
               type="text"
               [(ngModel)]="filters.address_postcode">
      </div>
    </div>

    <small class="text-muted form-text">
      Multiple {{ orgConfigService.getPostcodeName(false, true) }}s may be entered, separated by commas.
    </small>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.gender = undefined">
      Clear
    </button>

    <label>Gender</label>

    <div class="form-check">
      <input class="form-check-input" type="radio" name="gender" id="gender_male"
             [value]="Gender.male" [(ngModel)]="filters.gender">
      <label class="form-check-label" for="gender_male">
        Male
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="gender" id="gender_female"
             [value]="Gender.female" [(ngModel)]="filters.gender">
      <label class="form-check-label" for="gender_female">
        Female
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="gender" id="gender_nonbinary"
             [value]="Gender.nonbinary" [(ngModel)]="filters.gender">
      <label class="form-check-label" for="gender_nonbinary">
        Nonbinary
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="gender" id="gender_prefernot"
             [value]="Gender.prefer_not_to_say" [(ngModel)]="filters.gender">
      <label class="form-check-label" for="gender_prefernot">
        Prefer not to say
      </label>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_opted_in_to_marketing = undefined">
      Clear
    </button>

    <label>Marketing Opt-In</label>

    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_opted_in_to_marketing" id="has_opted_in_to_marketing_true"
             [value]="true" [(ngModel)]="filters.has_opted_in_to_marketing">
      <label class="form-check-label" for="has_opted_in_to_marketing_true">
        Has opted in to marketing
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_opted_in_to_marketing" id="has_opted_in_to_marketing_false"
             [value]="false" [(ngModel)]="filters.has_opted_in_to_marketing">
      <label class="form-check-label" for="has_opted_in_to_marketing_false">
        Has not opted in to marketing
      </label>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.check_in_count_min = undefined;filters.check_in_count_max = undefined;">
      Clear
    </button>

    <label>Number Of Lifetime Check-Ins</label>

    <div class="row">
      <div class="col-6 form-group pl-0">
        <label for="check_in_count_min">Minimum</label>
        <input class="form-control" id="check_in_count_min" name="check_in_count_min"
               type="number" min="0" step="1"
               [(ngModel)]="filters.check_in_count_min">
      </div>
      <div class="col-6 form-group pl-0">
        <label for="check_in_count_max">Maximum</label>
        <input class="form-control" id="check_in_count_max" name="check_in_count_max"
               type="number" min="0" step="1"
               [(ngModel)]="filters.check_in_count_max">
      </div>
    </div>
  </div>

  <hr>

  <div class="form-group">
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-outline-primary btn-sm float-right"
                (click)="clearTags();">
          Clear
        </button>

        <label>Tags</label>

        <ul *ngIf="filters.tags" style="padding-left: 20px;">
          <li *ngFor="let tag of filters.tags.split(',')">
            {{ tag }}
            (<span class="text-danger cursor-pointer" (click)="removeTag(tag)">Remove</span>)
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <input type="text" class="form-control"
               placeholder="Type here to add a tag"
               [(ngModel)]="tagSearchInput"
               [ngbTypeahead]="handleTagsTypeahead"
               [editable]="false"
               (selectItem)="addTag($event.item);$event.preventDefault();">
      </div>
    </div>

    <div class="row mt-2" *ngIf="filters.tags">
      <div class="col-12">
        <select class="form-control"
                [ngModel]="getMatchMode('tags_match')"
                (ngModelChange)="setMatchMode('tags_match', $event)">
          <option [ngValue]="FilterMatchMode.all">Match all of the selected tags</option>
          <option [ngValue]="FilterMatchMode.any">Match any of the selected tags</option>
        </select>
      </div>
    </div>

    <small class="text-muted" *ngIf="filters.tags">A customer must have {{ getMatchMode('tags_match') === FilterMatchMode.any ? 'at least one' : 'all' }} of the selected tags in order to match this filter.</small>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="clearReservationFields();">
      Clear
    </button>

    <label>Event Reservation</label>

    <div class="row">
      <div class="col-12 pl-0 pb-2">
        <label for="eventTypeSearchInput">
          Event Name
        </label>

        <div *ngIf="hasReservationEventType !== null" class="ml-2">
          {{ hasReservationEventType.name }}
          <span *ngIf="hasReservationEventType.status === EventTypeStatus.retired">(Retired)</span>
          -
          <span class="text-danger cursor-pointer" (click)="hasReservationEventType = null;">Remove</span>
        </div>
        <input class="form-control" type="text"
               id="eventTypeSearchInput" name="eventTypeSearchInput"
               *ngIf="hasReservationEventType === null"
               [(ngModel)]="eventTypeSearchInput"
               [ngbTypeahead]="handleEventTypeTypeahead"
               [inputFormatter]="eventTypeTypeaheadFormatter"
               [resultFormatter]="eventTypeTypeaheadFormatter"
               [editable]="false"
               (selectItem)="hasReservationEventType = $event.item;$event.preventDefault();">
      </div>

      <div class="col-6 pl-0">
        <label for="hasReservationMinDate">On Or After</label>
        <app-date-picker [id]="'hasReservationMinDate'"
                         [(content)]="hasReservationMinDate"></app-date-picker>
      </div>
      <div class="col-6 pl-0">
        <label for="hasReservationMaxDate">On Or Before</label>
        <app-date-picker [id]="'hasReservationMaxDate'"
                         [(content)]="hasReservationMaxDate"></app-date-picker>
      </div>
    </div>

    <small class="text-muted form-text">
      For multi-part events, this dates apply to the first part of the event.
    </small>
  </div>

  <hr>

  <app-date-range-filter
    [label]="'Latest Check-In Date'"
    [idPrefix]="'latest_check_in_timestamp'"
    [(min)]="filters.latest_check_in_timestamp_min"
    [(max)]="filters.latest_check_in_timestamp_max"
    [(range)]="filters.latest_check_in_timestamp_range"
    [allowDaysAgo]="true"
    [(daysMin)]="filters.latest_check_in_timestamp_days_min"
    [(daysMax)]="filters.latest_check_in_timestamp_days_max"></app-date-range-filter>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="clearCheckInFields();">
      Clear
    </button>

    <label>Checked In At Least Once In Date Range</label>

    <div class="row">
      <div class="col-6 pl-0">
        <label for="hadCheckInMinDate">On Or After</label>
        <app-date-picker [id]="'hadCheckInMinDate'"
                         [(content)]="hadCheckInMinDate"></app-date-picker>
      </div>
      <div class="col-6 pl-0">
        <label for="hadCheckInMaxDate">On Or Before</label>
        <app-date-picker [id]="'hadCheckInMaxDate'"
                         [(content)]="hadCheckInMaxDate"></app-date-picker>
      </div>
      <div class="col-6 pl-0 mt-2">
        <label for="eventTypeSearchInput">
          Entry Method
        </label>

        <select class="custom-select"
                [(ngModel)]="hadCheckInEntryMethod">
          <option [ngValue]="null">Any</option>
          <option [ngValue]="CheckInEntryMethod.membership">Membership</option>
          <option [ngValue]="CheckInEntryMethod.entryPass">Entry Pass</option>
          <option [ngValue]="CheckInEntryMethod.eventRegistration">Event Booking</option>
          <option [ngValue]="CheckInEntryMethod.guestPass">Guest Pass</option>
          <option [ngValue]="CheckInEntryMethod.freeEntry">Free Entry</option>
        </select>
      </div>
    </div>

    <small class="text-muted form-text">
      Depending on the date range chosen, this filter may slow down your query substantially. For simple cases like "customers who checked in in the last week", use the Latest Check-In Date filter instead.
    </small>
  </div>

  <hr>

  <div class="form-group">
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-outline-primary btn-sm float-right"
                (click)="clearProficiencies();">
          Clear
        </button>

        <label>Proficiencies</label>

        <ul *ngIf="filters.has_proficiencies" style="padding-left: 20px;">
          <li *ngFor="let proficiencyIdStr of filters.has_proficiencies.split(',')">
            {{ getProficiencyNameForIdString(proficiencyIdStr) }}
            (<span class="text-danger cursor-pointer" (click)="removeProficiency(proficiencyIdStr)">Remove</span>)
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <input type="text" class="form-control"
               placeholder="Type here to add a proficiency"
               [(ngModel)]="proficiencySearchInput"
               [ngbTypeahead]="handleProficienciesTypeahead"
               [inputFormatter]="proficiencyTypeaheadFormatter"
               [resultFormatter]="proficiencyTypeaheadFormatter"
               [editable]="false"
               (selectItem)="addProficiency($event.item);$event.preventDefault();">
      </div>
    </div>

    <div class="row mt-2" *ngIf="filters.has_proficiencies">
      <div class="col-12">
        <select class="form-control"
                [ngModel]="getMatchMode('has_proficiencies_match')"
                (ngModelChange)="setMatchMode('has_proficiencies_match', $event)">
          <option [ngValue]="FilterMatchMode.all">Match all of the selected proficiencies</option>
          <option [ngValue]="FilterMatchMode.any">Match any of the selected proficiencies</option>
        </select>
      </div>
    </div>

    <small class="text-muted" *ngIf="filters.has_proficiencies">A customer must have {{ getMatchMode('has_proficiencies_match') === FilterMatchMode.any ? 'at least one' : 'all' }} of the selected proficiencies in order to match this filter.</small>
  </div>

  <hr>

  <div class="form-group">
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-outline-primary btn-sm float-right"
                (click)="clearAssociations();">
          Clear
        </button>

        <label>Associations</label>

        <ul *ngIf="filters.has_association_memberships" style="padding-left: 20px;">
          <li *ngFor="let assocIdStr of filters.has_association_memberships.split(',')">
            {{ getAssociationNameForIdString(assocIdStr) }}
            (<span class="text-danger cursor-pointer" (click)="removeAssociation(assocIdStr)">Remove</span>)
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <input type="text" class="form-control"
               placeholder="Type here to add an association"
               [(ngModel)]="associationSearchInput"
               [ngbTypeahead]="handleAssociationsTypeahead"
               [inputFormatter]="associationTypeaheadFormatter"
               [resultFormatter]="associationTypeaheadFormatter"
               [editable]="false"
               (selectItem)="addAssociation($event.item);$event.preventDefault();">
      </div>
    </div>

    <div class="row mt-2" *ngIf="filters.has_association_memberships">
      <div class="col-12">
        <select class="form-control"
                [ngModel]="getMatchMode('has_association_memberships_match')"
                (ngModelChange)="setMatchMode('has_association_memberships_match', $event)">
          <option [ngValue]="FilterMatchMode.all">Match all of the selected associations</option>
          <option [ngValue]="FilterMatchMode.any">Match any of the selected associations</option>
        </select>
      </div>
    </div>

    <small class="text-muted" *ngIf="filters.has_association_memberships">A customer must be a member of {{ getMatchMode('has_association_memberships_match') === FilterMatchMode.any ? 'at least one' : 'all' }} of the selected associations in order to match this filter.</small>
  </div>

  <hr>

  <div class="form-group">
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-outline-primary btn-sm float-right"
                (click)="clearChallengeFields();">
          Clear
        </button>

        <label>Has Challenge</label>

        <ul *ngIf="hasChallengeSelections" style="padding-left: 20px;">
          <li *ngFor="let challenge of hasChallengeTypes">
            {{ challenge.name }}
            <span *ngIf="challenge.status === ChallengeStatus.retired">(Retired)</span>
            (<span class="text-danger cursor-pointer" (click)="removeChallenge(challenge)">Remove</span>)
          </li>
          <li *ngFor="let unresolvedId of hasChallengeUnresolvedIds">
            Unknown challenge (ID {{ unresolvedId }})
            (<span class="text-danger cursor-pointer" (click)="removeUnresolvedChallengeId(unresolvedId)">Remove</span>)
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <input class="form-control" type="text"
               id="challengeSearchInput" name="challengeSearchInput"
               placeholder="Type here to add a challenge"
               [(ngModel)]="challengeSearchInput" [ngbTypeahead]="handleChallengeTypeahead"
               [inputFormatter]="challengeTypeaheadFormatter"
               [resultFormatter]="challengeTypeaheadFormatter"
               [editable]="false"
               (selectItem)="addChallenge($event.item);$event.preventDefault();">
      </div>
    </div>

    <div class="row mt-2" *ngIf="hasChallengeSelections">
      <div class="col-12">
        <select class="form-control"
                [(ngModel)]="hasChallengeMatchMode">
          <option [ngValue]="FilterMatchMode.all">Match all of the selected challenges</option>
          <option [ngValue]="FilterMatchMode.any">Match any of the selected challenges</option>
        </select>
      </div>
    </div>

    <div class="row mt-2" *ngIf="hasChallengeSelections">
      <div class="col-12">
        <select class="custom-select"
                [(ngModel)]="hasChallengeIsComplete">
          <option [ngValue]="null">All customers with challenge</option>
          <option [ngValue]="true">Customers who have completed challenge</option>
          <option [ngValue]="false">Customers who have not completed challenge</option>
        </select>
      </div>
    </div>

    <div class="row mt-2"
         *ngIf="hasChallengeSelections && (hasChallengeIsComplete === true)">
      <div class="col-6">
        <label for="hasChallengeMinCompletedDate">Completed On Or After</label>
        <app-date-picker [id]="'hasChallengeMinCompletedDate'"
                         [(content)]="hasChallengeMinCompletedDate"></app-date-picker>
      </div>
      <div class="col-6">
        <label for="hasChallengeMaxCompletedDate">Completed On Or Before</label>
        <app-date-picker [id]="'hasChallengeMaxCompletedDate'"
                         [(content)]="hasChallengeMaxCompletedDate"></app-date-picker>
      </div>
    </div>

    <small class="text-muted" *ngIf="hasChallengeSelections">A customer must have {{ hasChallengeMatchMode === FilterMatchMode.any ? 'at least one' : 'all' }} of the selected challenges in order to match this filter.</small>
  </div>

  <hr>

  <div class="form-group">
    <button type="button" class="btn btn-outline-primary btn-sm float-right"
            (click)="filters.has_profile_image = undefined">
      Clear
    </button>

    <label>Profile Image</label>

    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_profile_image" id="has_profile_image_true"
             [value]="true" [(ngModel)]="filters.has_profile_image">
      <label class="form-check-label" for="has_profile_image_true">
        Has a profile image
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="has_profile_image" id="has_profile_image_false"
             [value]="false" [(ngModel)]="filters.has_profile_image">
      <label class="form-check-label" for="has_profile_image_false">
        Does not have a profile image
      </label>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="handleClearAll()">
    Clear All
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSubmit()">
    Apply
  </button>
</div>
